<!--
 * @Description:目录树
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-06-02 16:52:03
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
      <a-button class="ml-4" type="primary" @click="appendCatalog()" v-action:catalog icon="plus">
        添加根目录
      </a-button>
    </div>
    <a-card :bordered="false">
      <a-tree default-expand-all :treeData="treeData">
        <template slot="custom" slot-scope="item">
          <span>{{ item.title }}</span>
          <template>
            <span class="d-flex actions">
              <a-button
                type="link"
                size="small"
                v-action:catalog
                @click="appendCatalog(item.id)"
              >添加子目录</a-button
              >
              <a-button
                type="link"
                size="small"
                v-action:catalog
                @click="editCatalog(item.id)"
              >修改目录</a-button
              >
              <a-button
                type="link"
                size="small"
                v-if="!(item.children && item.children.length > 0)"
                v-action:content
                @click="appendContent(item.title, item.id, item.content ? 'edit' : 'add')"
              >{{ item.content ? '修改内容' : '添加内容' }}</a-button
              >
              <a-popconfirm
                title="确定要删除该条章节吗？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="handleOnDelete(item.id)"
                v-action:delete
                v-if="!(item.children && item.children.length)"
              >
                <a href="#">删除</a>
              </a-popconfirm>
            </span>
          </template>
        </template>
      </a-tree>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { Tree } from 'ant-design-vue'
import { tree } from '@/mixins' // 引入
import { GoBack } from '@/components'
import { CatalogForm, ContentForm } from './modules'

const apiList = {
    delete: '/books/contents/'
}

export default {
    name: 'BookContentList',
    mixins: [tree], // 使用mixins
    components: {
        CatalogForm,
        ContentForm,
        ATree: Tree,
        GoBack
    },
    data () {
        return {
            apiList
        }
    },
    mounted () {
        if (this.$route.params.id) {
            apiList.getList = '/books/' + this.$route.params.id + '/contents'
            this.getTreeLists()
        }
    },
    methods: {
        /**
         * 添加内容
         * @Jdy
         * @2021-4-7
         */
        appendContent (title, data, type) {
            const that = this
            that.$dialog(
                ContentForm,
                {
                    id: data,
                    type: type,
                    on: {
                        ok () {
                            that.getTreeLists()
                        }
                    }
                },
                {
                    title: title,
                    centered: true,
                    okText: '提交',
                    width: 700,
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        },
        /**
         * 添加目录
         * @Jdy
         * @2021-4-7
         */
        appendCatalog (data) {
            // 添加
            const that = this
            that.$dialog(
                CatalogForm,
                {
                    pid: data,
                    bid: Number(that.$route.params.id),
                    on: {
                        ok () {
                            that.getTreeLists()
                        }
                    }
                },
                {
                    title: '目录',
                    centered: true,
                    okText: '提交',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        },
        /**
         * 编辑目录
         * @jdy
         * @2021-4-7
         */
        editCatalog (id) {
            const that = this
            that.$dialog(
                CatalogForm,
                {
                    id,
                    on: {
                        ok () {
                            that.getTreeLists()
                        }
                    }
                },
                {
                    title: '修改目录',
                    centered: true,
                    okText: '提交',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-tree-title {
    width: 100%;
    display: flex;
    &:hover {
        .actions {
            display: block;
        }
    }
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
}

.ant-card-body {
    :global {
        .ant-tree {
            line-height: 3;
            li {
                position: relative;
            }
        }
    }
}
.actions {
    display: none;
}
</style>
